module.exports = __webpack_public_path__ + "static/media/speakerSix.cc278c3b.jpg";